"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatContainer = void 0;
class ChatContainer {
    _id;
    name;
    orgname;
    image;
    ip;
    activeClients;
    status;
    // if this container was just registered, use to determine if we should sync users
    new;
    lastUpdate;
}
exports.ChatContainer = ChatContainer;
